import { render, staticRenderFns } from "./usuarioPeriodos.vue?vue&type=template&id=6baa884e"
import script from "./usuarioPeriodos.vue?vue&type=script&lang=js"
export * from "./usuarioPeriodos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports